import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GeneralChat from './pages/GeneralChat';
import Settings from './pages/Settings';
import Chat from './pages/Chat';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { isAuthenticated } from './services/AuthService';
import { useSecurity } from './hooks/useSecurity';

// ── Route guards ──────────────────────────────────────────────────────────────

/** Any authenticated user (including guests) */
function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
}

/** Admin panel guard */
function AdminRoute({ children }) {
  const token = localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/admin" replace />;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('adminToken');
      return <Navigate to="/admin" replace />;
    }
  } catch {
    return <Navigate to="/admin" replace />;
  }
  return children;
}

// ── Routes ────────────────────────────────────────────────────────────────────
function AppRoutes() {
  useSecurity(); // force logout on any devtools inspect attempt

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Login />} />

      {/* Protected routes */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/general-chat" element={<ProtectedRoute><GeneralChat /></ProtectedRoute>} />
      <Route path="/chat/:chatCode" element={<ProtectedRoute><Chat /></ProtectedRoute>} />

      
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      {/* Admin panel */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
